// @flow
import React from "react";
import styled from "styled-components";

import Gettext from "../components/common/Gettext";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-display: flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-align-content: flex-start;
  align-content: flex-start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding-top: 62px;
  text-align: center;
  color: #fff;
  background-color: ${props => props.theme.main};
  background-size: cover;

  @media (max-width: 959px) {
    -webkit-align-content: center;
    align-content: center;
    -webkit-justify-content: center;
    justify-content: center;
    padding-top: 0;
  }
`;

const Logo = styled.div`
  height: 79px;
  width: 100%;
  margin-bottom: 62px;
  background: url(${props => props.theme.logoImg}) center no-repeat;
  background-size: contain;

  @media (max-width: 959px) {
    height: 45px;
    margin-bottom: 33px;
  }
`;

const Svg = styled.svg`
  display: block;
  width: 105px;
  height: auto;
  margin-bottom: 40px;
  fill: none;
  stroke: ${props => props.theme.accent};
  stroke-linejoin: round;
  stroke-width: 2px;

  @media (min-width: 480px) and (max-width: 959px) {
    width: 55px;
    margin-bottom: 23px;
  }
`;

const Text = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto 40px;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
  color: ${props => props.theme.accent};

  @media (max-width: 959px) {
    padding: 0 30px;
    font-size: 18px;
  }
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 2.611em;
  margin-left: 0.556em;
  padding: 0 0.944em;
  font-weight: 700;
  font-size: 20px;
  color: #fff;
  text-shadow: -1px -1px #56a008;
  border-radius: 0.5em;
  border: none;
  border-bottom: 2px solid #4e8418;
  box-shadow: inset 0px -1px 0px 0px ${props => props.theme.upperBoxShadow};
  background-color: ${props => props.theme.upper};
  background: linear-gradient(
    to top,
    ${props => props.theme.upper},
    ${props => props.theme.upperAccent}
  );
  cursor: pointer;

  :hover,
  :focus,
  :active {
    box-shadow: inset 0px -1px 0px 0px rgba(99, 191, 0, 1);
    background-color: ${props => props.theme.upperAccent};
    background: linear-gradient(
      to top,
      ${props => props.theme.upperAccent},
      ${props => props.theme.upper}
    );
  }

  @media (max-width: 959px) {
    font-size: 18px;
  }
`;

function Icon() {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <g>
        <circle cx="16" cy="16" r="15" />
        <polyline points="8 16 13 21 24 10" />
      </g>
    </Svg>
  );
}

function UpdateScreen(props: {}) {
  return (
    <Container>
      <Logo />
      <Icon />
      <Text>
        <Gettext>
          The application was updated while you were trading. Please refresh
          this page to continue.
        </Gettext>
      </Text>
      <Button
        onClick={() => {
          document.location.reload();
        }}
      >
        <Gettext>Reload</Gettext>
      </Button>
    </Container>
  );
}

export default UpdateScreen;



// WEBPACK FOOTER //
// ./src/components/UpdateScreen.js